// The default number of blank rows to show while table rows are being fetched.
export const DEFAULT_LOADING_ROWS = 3;
